import { UTCDate } from 'types';
import { ValidationMessageProvider, ObjectValidator, ValidationConfig, ValidationResult } from 'validation';
import { AppContext } from '../control/context';
import { FeaturesImpl } from '../model/features-impl';

class ValidationMessageProviderImpl<T> implements ValidationMessageProvider<T> {
  constructor(private appContext: AppContext, private name: string, private doIndexes: boolean) {}

  getMessage(obj: any, path: string, code: string): string {
    if (code.startsWith('{')) {
      return code;
    }
    let indexes = '';
    const matches = path.match(/\[\d+\]/g);
    if (matches) {
      path = path.replace(/\[\d+\]/g, '');
      if (this.doIndexes) {
        for (const match of matches) {
          indexes += +match.slice(1, -1) + 1 + ': ';
        }
      }
    }
    const key = 'VALIDATION.' + this.name + '.' + code + '.' + path;
    return indexes + this.appContext.getI18NString(key);
  }
}

export class ValidationBuilder {
  private objectValidator: ObjectValidator<any>;

  constructor(appContext: AppContext, features: any, doIndexes?: boolean) {
    const validationSpecification = FeaturesImpl.getValidationSpecification(features);
    const validationConfig = new ValidationConfig<any>();
    validationConfig.additionalRules = validationSpecification.additionalRules;
    validationConfig.specification = validationSpecification.specification;
    validationConfig.warnings = validationSpecification.warnings;
    validationConfig.notifications = validationSpecification.notifications;
    validationConfig.messageProvider = new ValidationMessageProviderImpl<any>(
      appContext,
      features.constructor.name,
      doIndexes === undefined ? true : doIndexes,
    );
    this.objectValidator = new ObjectValidator<any>(validationConfig);
  }

  private static augmentObject(today: UTCDate, obj: any, parent?: any) {
    if (obj instanceof Object) {
      for (const property in obj) {
        ValidationBuilder.augmentObject(today, obj[property], obj);
      }
      obj['^'] = parent;
      if (!parent) {
        obj['#TODAY#'] = today;
      }
      if (obj.hasOwnProperty('value')) {
        obj.toString = () => obj.value;
      }
    }
  }

  validate(features: any, today: UTCDate): ValidationResult {
    const obj = JSON.parse(JSON.stringify(features));
    ValidationBuilder.augmentObject(today, obj);
    const result = this.objectValidator.validate(obj);
    for (const err of result.getErrors()) {
      err.path = err.path.replace(/\[/g, '.').replace(/]/g, '');
    }
    return result;
  }
}
